var animarOnViewRect = (function(){
	var jaVerificou = false;
	function verificaSeEstaNaViewport () {
		$('[data-animar]').each(function(){
			var animacao = $(this).data('animar');
			var alturaDaViewport = window.innerHeight;
			var positicaoDoElemento = this.getBoundingClientRect().top;
			if(positicaoDoElemento < (alturaDaViewport-100)){
				$(this).addClass(animacao);
			}
		});
	}
	verificaSeEstaNaViewport();
	$(window).scroll(function(){
		verificaSeEstaNaViewport()
	});
})();